import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=19bf0e51&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"
import style0 from "./Topic.vue?vue&type=style&index=0&id=19bf0e51&prod&lang=scss&scoped=true"
import style1 from "./Topic.vue?vue&type=style&index=1&id=19bf0e51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf0e51",
  null
  
)

export default component.exports